import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { getCardColor } from '../../utils/styling'
import { Box } from '../UI/Box'

export const StyledLink = styled(Link)`
  width: 100%;
  height: 100%;
  position: relative;
`

export const Image = styled.img<{ isLoading?: boolean }>`
  max-height: 604px;
  max-width: 662px;
  width: 100%;
  object-fit: cover;

  @media screen and (max-width: 1000px) {
    max-width: 344px;
    max-height: 274px;
  }
`

export const ContentWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const Logo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;

  @media screen and (min-width: 1000px) {
    width: 70px;
    height: 70px;
  }
`

export const DescriptionText = styled.p`
  color: ${({ theme }) => theme.colors.brandPrimaryText};
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'dlig' on, 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 127.273% */
  letter-spacing: -0.88px;

  @media screen and (max-width: 1000px) {
    font-size: 14px;
    line-height: 22px;
  }
`

type LiveTimerProps = {
  isLive: boolean
  isTimer?: boolean
  shouldAnimate?: boolean
}

export const OpeningLabel = styled(Box)<LiveTimerProps>`
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 20;
  height: 20px;
  width: auto;
  padding: 2px 8px;
  background: ${getCardColor};
  border-radius: 4px;
  flex: 0;
  span {
    font-family: 'Space Grotesk';
    font-size: 11px;
    line-height: 12px;
    color: ${({ isLive, theme }) => (isLive ? '#00FFA3' : 'black')};
    text-transform: uppercase;
  }
`

export const ProgressContainer = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 20;
  padding: 16px;
  background: linear-gradient(0deg, #000000 20.18%, rgba(0, 0, 0, 0) 96%);
  span.title {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.05em;
    opacity: 0.5;
    margin-bottom: 8px;
    z-index: 20;
    color: #fff;
  }
  span.pct {
    font-family: 'Space Grotesk';
    font-style: normal;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #f7f8ff;
  }

  span.time-text {
    font-family: 'Space Grotesk';
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0.5;
    margin: 0;
  }

  div.bar {
    flex: 3;
  }
  div.timer {
    flex: 2;
    margin-left: 16px;
    @media screen and (max-width: 1000px) {
      flex: 3;
    }
  }
`
